module.exports = __webpack_public_path__ + "static/marco_bonomo-9ecfc081ed4504f519862d992ed7f891.jpg";